import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import PillarsSection from "../../components/PillarsSection/PillarsSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import PrayerTime from "../../components/PrayerTime/PrayerTime";
import About2 from "../../components/about2/about2";
import ServiceSectionS2 from "../../components/ServiceSectionS2/ServiceSectionS2";
import { AboutTeamSection } from "./AboutTeamSection";
import HistorySection from "../../components/road-map/HistorySection";
import JourneyTimeline from "../../components/road-map/JourneyTimeline";

const AboutPage = () => {
  const { t } = useTranslation("about");
  return (
    <Fragment>
      <Navbar />
      <PageTitle pageTitle={t("pageTitle")} pagesub={t("pageTitle")} />
      <About2 detail={true} />
      <PillarsSection />
      <AboutTeamSection />
      <HistorySection />
      <JourneyTimeline />
      <ServiceSectionS2 />
      <PrayerTime />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AboutPage;
